import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';
import {
  MergedRecurrentApplicationResource,
  recurrentApplicationsPost,
  RecurrentApplicationResource,
} from '~/generated';
import { extractData } from '~/utils/query-utils';

export const useCreateRecurrentApplication = (
  publisherId: number | undefined,
  options: UseMutationOptions<
    RecurrentApplicationResource,
    unknown,
    MergedRecurrentApplicationResource,
    unknown
  >
) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (recurrentApplication) => {
      if (publisherId == null) {
        throw new Error('no publisher id given');
      }
      return extractData(
        recurrentApplicationsPost({
          path: { publisherId },
          body: recurrentApplication,
        })
      );
    },
    ...options,
    onSuccess(...args) {
      queryClient.invalidateQueries({ queryKey: ['recurrentApplications'] });
      options.onSuccess?.(...args);
    },
  });
};
